module.exports = __webpack_public_path__ + "static/img/img_bg_text.255c2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/savethetrees/img_bg_text.png
// module id = 7obz
// module chunks = 0